// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://knglzfkfgzevqqeslivo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtuZ2x6ZmtmZ3pldnFxZXNsaXZvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg5MDk5NDMsImV4cCI6MjA2NDQ4NTk0M30.uVBatJQbxAa79z2pOeK92U7_fdXxyc9XLdx0kucJEoE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);